import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Button from "reactstrap/es/Button"
import DeleteLabelModal from "./DeleteLabelModal"

class DeleteSelectItem extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const {resetBulkAll, selectedItems} = this.props
        const r = window.confirm(`Are you sure want to delete label for ${selectedItems.length} ${selectedItems.length > 1 ? 'orders' : 'order'} selected?`)

        if (r !== true) {
            resetBulkAll()
            return
        }

        const {isOpen} = this.state

        this.setState({
            isOpen: !isOpen
        })
    }

    _closePopup = () => {
        this.setState({
            isOpen: false
        })
    }

    render() {
        const {isOpen} = this.state

        return (
            <div className="DeleteSelectItem">
                <Button color="link" onClick={this._handleToggleModal} className="mr-1">Delete label</Button>
                {isOpen && (
                    <DeleteLabelModal
                        {...this.props}
                        isOpen={isOpen}
                        handleToggleModal={this._closePopup}
                    />
                )}
            </div>
        )
    }
}

DeleteSelectItem.propTypes = {
    selectedItems: PropTypes.array.isRequired
}

export default DeleteSelectItem